export default __webpack_public_path__ + "media/images/icons/app-5-297f7c24f30190553dc56e75d67f8ca7.png";